/**
 * WARNING: Do not store any sensitive or unnecessary values in cookies.
 * Cookies should be used minimally due to security concerns and data limitations.
 * Consider using alternative storage methods (localStorage, sessionStorage, or server-side storage)
 * unless cookies are specifically required.
 */

import Cookies from 'universal-cookie';

const cookies = new Cookies();
const set = (name, value) => {
  try {
    cookies.set(name, value);
  } catch (e) {
    console.log('cookie error', e);
  }
};

const get = (name) => cookies.get(name);

export default {
  set,
  get,
};
